<template>
  <!-- 悬挂 -->
  <div class="showwhatsapp">
    <!-- <a
      style="text-decoration: none;"
      href="https://api.whatsapp.com/send?phone=85264586539"
      target="_blank"
    >
      <i style="color: #24cd64;" data-v-6c4d8baa class="iconfont icon-social-whatsapp"></i>
    </a> -->
    <!-- <el-backtop :visibility-height="0">
      <div class="goTop">
        <a
          style="text-decoration: none"
          href="https://api.whatsapp.com/send?phone=85264586539"
          target="_blank"
        >
          <i
            style="color: #24cd64"
            data-v-6c4d8baa
            class="iconfont icon-social-whatsapp"
          ></i>
        </a>
        <div class="gtop">
          <img src="../assets/images/top.png" alt="" />
        </div>
        <div></div>
      </div>
    </el-backtop> -->
    <div
      id="gtop"
      style="
        position: fixed;
        right: 2%;
        bottom: 8%;
        padding: 0.5%;
        background: rgb(27, 30, 30);
        cursor: pointer;
        z-index:999
      "
      @click="goTop"
    >
      <a
        style="text-decoration: none"
        href="https://api.whatsapp.com/send?phone=85264586539"
        target="_blank"
      >
        <i
          style="color: #24cd64"
          data-v-6c4d8baa
          class="iconfont icon-social-whatsapp"
        ></i>
      </a>
      <img src="../assets/images/top.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "showwhatsapp",
  data() {
    return {};
  },
  methods: {
    goTop() {
      var timer = null;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        var oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    },
  },
};
</script>

<style>
#gotop {
  background-color: rgb(27, 30, 30);
  padding: 12%;
  z-index: 9999;
}
#gtop i {
  font-size: 1.6rem;
  position: absolute;
  top: 60%;
  left: -70%;
  text-align: center;
  width: auto;
  height: auto;
  padding: 25%;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 0 5px 2px rgba(151, 144, 136, 0.5);
}
.goTop div:last-child {
  content: "";
  clear: both;
}
.goTop a {
  text-align: center;
}
.gtop {
  background-color: rgb(27, 30, 30);
  text-align: center;
  padding: 15% 0;
  width: 3.5rem;
}
.el-backtop {
  width: 6rem;
  height: 6rem;
  background-color: transparent;
  box-shadow: 0 0 0 0;
  right: 10px !important;
  position: fixed;
  bottom: 2%;
}
.el-backtop:hover {
  background-color: transparent;
}
.showwhatsapp {
  /* position: fixed;
  bottom: 2%;
  z-index: 999;
  right: 0;
  border: 1px solid;
  padding: 10px 3%; */
  /* box-shadow: 0 1px 10px 5px rgb(64, 64, 64, 0.3); */
  /* border-radius: 20px 0 0 20px;
  border: none;*/
  background: rgba(151, 144, 136, 0.5);
}
@media (max-width: 820px) {
  .showwhatsapp i {
    font-size: 2rem;
  }
}
</style>
